// src/components/Footer.tsx
import React from "react";
import { FaInstagram, FaLinkedin, FaEnvelope } from "react-icons/fa";
import { analytics, EVENTS } from "../analytics";
import { Link } from "react-router-dom";
const Footer: React.FC = () => {
  return (
    <footer className="bg-main text-white py-10">
      <div
        className="
      max-w-6xl mx-auto px-6
      flex flex-col md:flex-row
      items-center md:items-center
      justify-center
      gap-8 md:gap-20
    "
      >
        {/* Logo */}
        <div className="flex items-center">
          {/* <img
            src="/white_transparent.png"
            alt="BeMe Logo"
            className="h-40"
          /> */}
          <Link
            to="/"
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
              analytics.track(EVENTS.CLICK_FOOTER_HOME);
            }}
            className="inline-flex items-center"
          >
            <img
              src="/white_transparent.png"
              alt="BeMe Logo"
              className="h-40"
            />
          </Link>
        </div>

        {/* Contacts */}
        <div>

          <ul
            className="
              flex flex-col md:flex-row
              items-center
              gap-3 md:gap-5
              text-sm
            "
          >
            <li className="flex items-center gap-2">
              <FaLinkedin className="text-accent" />
              <a
                href="https://www.linkedin.com/groups/16346062/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-accent transition"
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  analytics.track(EVENTS.CLICK_FOOTER_LINKEDIN_COMMUNITY);
                }}
              >
                LinkedIn Community
              </a>
            </li>



            {/* Divider */}
            <span className="hidden md:inline text-gray-400">|</span>

            <li className="flex items-center gap-2">
              <FaLinkedin className="text-accent" />
              <a
                href="https://www.linkedin.com/company/beme-consulting"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-accent transition"
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  analytics.track(EVENTS.CLICK_FOOTER_LINKEDIN);
                }}
              >
                BeMe Consulting
              </a>
            </li>

            <span className="hidden md:inline text-gray-400">|</span>

            <li className="flex items-center gap-2">
              <FaInstagram className="text-accent" />
              <a
                href="https://instagram.com/beme.consulting"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-accent transition"
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  analytics.track(EVENTS.CLICK_FOOTER_INSTAGRAM);
                }}
              >
                @beme.consulting
              </a>
            </li>

            <span className="hidden md:inline text-gray-400">|</span>


            <li className="flex items-center gap-2">
              <FaEnvelope className="text-accent" />
              <a
                href="mailto:info@bemeconsulting.com"
                className="hover:text-accent transition"
                onClick={() => {
                  analytics.track(EVENTS.CLICK_FOOTER_EMAIL);
                }}
              >
                info@bemeconsulting.com
              </a>
            </li>


          </ul>
        </div>

      </div>

      {/* Footer Bottom */}
      <div className="border-t border-gray-700 mt-8 pt-4 text-center text-xs text-gray-400">
        © {new Date().getFullYear()} BeMe. All rights reserved.
      </div>
    </footer>

  );
};

export default Footer;
